// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17jGL","newExpiryDate":"styles_newExpiryDate__2Hhqe","footer":"styles_footer__2lTXR"};